export default __webpack_public_path__ + "static/champion-htf-lightweight-webfont-d7ef996495f285a15e6114597e298b9b.ttf";